
import { apis } from "../../constants/apis";
import httpService from "../httpService";
import { getStaticConfigs } from "../../helpers/common";
import axios from '../../utils/axios'

class MetaKeyService
{
  GetDetailMetaKey(id: string)
  {
    return httpService.get(`${apis.metaKey.default}/${id}`);
  }
}

export default new MetaKeyService();

export async function getMetakey(payload: any)
{
  return httpService.get(`${apis.metaKey.default}`, {
    params: payload,
  });
}

export async function getInfor()
{
  //user+ admin
  const staticConfigs = await getStaticConfigs();
  const _url =
    (staticConfigs?.REACT_APP_API_KARATOS ?? "") +
    `/sessions/whoami`

  return axios.get(_url);
}

export async function getGlobalConfigs(name: string)
{
  return httpService.get(`/api/v1/global-configs/by-name/${name}`);
}

export async function getGroup()
{
  return httpService.get(`/api/v1/groups`);
}

export async function getApplicationConfigs()
{
  const staticConfigs = await getStaticConfigs();

  // In OAUTH2 mode the UI config is served as static JSON from /public
  // instead of the API. Returns an axios-like shape ({ data }) so callers stay unchanged.
  if (staticConfigs?.REACT_APP_AUTHENTICATION_METHOD === "OAUTH2")
  {
    const res = await fetch("/ui-config.json", { cache: "no-store" });
    return { data: await res.json() };
  }

  const _url =
    (staticConfigs?.REACT_APP_API_BASE_URL ?? "") +
    `/ailbl/configs/vmrs/ui-config`

  return axios.get(_url);
}


// export async function getConfigsDetailPage(key?: string)
// {
//   const staticConfigs = await getStaticConfigs();

//   const _url =
//     (staticConfigs?.REACT_APP_API_BASE_URL ?? "") +
//     `/ailbl/configs/eom/${key}`;

//   return axios.get(_url);
// }


export async function getConfigByKey(key: string)
{
  return httpService.get(apis.config.detail, { params: { key } });
}

export async function getCommonSystem()
{
  const staticConfigs = await getStaticConfigs();

  // In OAUTH2 mode the common config is served as static JSON from /public
  // instead of the API. Returns an axios-like shape ({ data }) so callers stay unchanged.
  if (staticConfigs?.REACT_APP_AUTHENTICATION_METHOD === "OAUTH2")
  {
    const res = await fetch("/web-common.json", { cache: "no-store" });
    return { data: await res.json() };
  }

  const _url =
    (staticConfigs?.REACT_APP_API_BASE_URL ?? "") +
    `/ailbl/web-vmrs-common`;

  return axios.get(_url);
}